import React from "react";
import "./style/basketTableStyle.css";
import { TrashOutline } from "react-ionicons/lib";
import { BasketItem } from "../../models/BasketItem";

const colorIcon = "var(--primary-color)";

interface IProps {
  basket: BasketItem[];
  onRemoveBasket: (index: number) => void;
}

const BasketTable: React.FC<IProps> = ({ basket, onRemoveBasket }: IProps) => {
  return (
    <div className={`basket-table`}>
      <div className={"basket-header"}>
        <div>Szczegóły biletu</div>
        <div>Ilość</div>
        <div>Wartość</div>
        <div>Usuń</div>
      </div>
      {basket.map((item, index) => (
        <div key={index} className={"basket-body"}>
          <div>
            {item.ticketAccess.length > 0 && <p>{item.ticketAccess[0].exerciseName}</p>}
            <p>{item.assortName}</p>
            {item.ticketAccess.length > 0 && (
              <p>
                Rząd: {item.ticketAccess[0].rowName}, miejsce: {item.ticketAccess[0].seatName}
              </p>
            )}
          </div>
          <div>{item.qnt}</div>
          <div>{item.price} zł</div>
          <div>
            <TrashOutline
              color={colorIcon}
              title={""}
              height="30px"
              width="30px"
              onClick={() => onRemoveBasket(index)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default BasketTable;
